import { Button } from '@mui/material';
import React, { useContext } from 'react';
import { AppearanceContext } from '../../../contexts';
import { AvailableThemes } from '../../../contexts/AppearanceContext';

const ThemeButton = (
  themeColor: AvailableThemes,
  hexColorPrimary: string,
  hexColorSecondary?: string,
) => {
  const appearanceContext = useContext(AppearanceContext);
  return (
    <Button
      sx={{
        minWidth: '24px',
        maxWidth: '24px',
        background: hexColorSecondary
          ? `linear-gradient(135deg, ${hexColorPrimary} 50%, ${hexColorSecondary} 50%)`
          : hexColorPrimary,
        padding: 0,
        height: '24px',
      }}
      onClick={() => {
        appearanceContext.setTheme(themeColor);
      }}
    />
  );
};

export default ThemeButton;
